// extracted by mini-css-extract-plugin
export var modal = "_fs-0";